module.exports = __webpack_public_path__ + "static/media/dot-preloader-dark.a1bf7c3c.svg";